import { render, staticRenderFns } from "./IngressosForm.vue?vue&type=template&id=1a08a7dd&scoped=true"
import script from "./IngressosForm.vue?vue&type=script&lang=js"
export * from "./IngressosForm.vue?vue&type=script&lang=js"
import style0 from "./IngressosForm.vue?vue&type=style&index=0&id=1a08a7dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08a7dd",
  null
  
)

export default component.exports